<template>
  <div class="marketPriceConfig">
    <div style="display: flex; justify-content: flex-end; margin-bottom: 15px">
      <el-button
        type="primary"
        icon="el-icon-plus"
        size="small"
        @click="CreateItem"
        >上传</el-button
      >
    </div>

    <el-table
      :data="TableList"
      :stripe="true"
      @selection-change="HandleSelectionChange"
      @sort-change="HandleSortChange"
    >
      <TableOperation
        :maxCount="3"
        :width="170"
        :operationList="[
          {
            is_show: (row) => true,
            label: '更新',
            command: 'EditItem',
          },
          {
            is_show: (row) => true,
            label: '下载',
            command: 'downloadItem',
          },
          {
            is_show: (row) => true,
            label: '删除',
            command: 'DeleteItem',
          },
        ]"
        @handleOperation="HandleOperation"
      />

      <el-table-column
        prop="info_time"
        label="日期"
        sortable="custom"
      ></el-table-column>

      <el-table-column
        prop="created_time"
        :label="l('创建时间')"
        sortable="custom"
        width="170"
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="HandleSizeChange"
      @current-change="HandleCurrentChange"
      :current-page="CurrentPage"
      :page-sizes="PageSizeList"
      :page-size="PageSize"
      layout="total, prev, pager, next, jumper"
      :total="TotalCount"
    ></el-pagination>

    <CreateOrEditMarketPrice
      ref="createOrEditDialog"
      @submitDialog="GetTableList"
    />
  </div>
</template>

<script>
import CreateOrEditMarketPrice from "./operation/CreateOrEditMarketPrice.vue";
import tableMixin from "@/assets/js/tableMixin";
export default {
  name: "MarketPriceConfig",
  mixins: [tableMixin],
  components: {
    CreateOrEditMarketPrice,
  },
  data() {
    return {
      SearchData: {
        info_time: "",
      },
      Sorting:"-info_time"
    };
  },
  created() {},
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;

      this.axios
        .get("/api/admin_market_price/", {
          params: {
            ...this.SearchData,
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.TableList = data.results;
        });
    },
    downloadItem(item) {
      window.open(item.file_url, "_blank");
    },
    DeleteItem(item) {
      console.log(item);
      this.$confirm(`是否删除${item.info_time}?`, "", {
        type: "warning",
      }).then(() => {
        this.axios
          .delete(`/api/admin_market_price/${item.id}/`)
          .then((response) => {
            this.GetTableList();
          });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.marketPriceConfig {
}
</style>

